"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
fragment Macronutrients on NutritionFacts {
  calories
  carbs
  fats
  fibers
  protein
}

query nutritionProgressForDay($userId: Int!, $date: String!){
  progressCollection (userId: $userId, range: { from: $date, to: $date } ){
    id
    day
    date
    calorieBudget {
      ...Macronutrients
    }
    calorieBudgetInfo {
        calories {
            status
            difference
            progress
        }
        carbs {
            status
            difference
            progress
        }
        fats {
            status
            difference
            progress
        }
        fibers {
            status
            difference
            progress
        }
        protein {
            status
            difference
            progress
        }
    }
    meals {
      isFromMenu
      isCalorieTracked
      hasImage
      imageWebPath
      time
      description
      nutritionFacts {
        ...Macronutrients
      }
      mealType
      nutrients {
        id
        name
        description
        time
        day
        created
        type
        nutritionFacts {
          ...Macronutrients
        }
        measure {
          value
          unit
        }
      }
    }
  }
}
`;
//# sourceMappingURL=getNutritionProgressForDayQuery.js.map